import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ListingDetails.css';
import cx from 'classnames';
import messages from '../../../locale/messages';

const ListBedTypes = ({ itemList, label, rooms }) => {
  // If we have room-based data, display rooms in cards
  if (rooms && rooms.length > 0) {
    return (
      <div className={cx(s.horizontalLineThrough)}>
        <div className={cx(s.space1)}>
          <p className={s.sectionTitleText}> {label} </p>
        </div>
        <div className={cx(s.spaceTop1)}>
          <div style={{
            display: 'flex',
            gap: '16px',
            overflowX: 'auto',
            paddingBottom: '12px',
            scrollbarWidth: 'thin'
          }}>
            {rooms.map((room, index) => (
              <div
                key={index}
                style={{
                  minWidth: '200px',
                  padding: '16px',
                  border: '1px solid #dce0e0',
                  borderRadius: '8px',
                  backgroundColor: '#fff'
                }}
              >
                <h4 style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  marginBottom: '12px',
                  color: '#484848'
                }}>
                  {room.roomType === 'shared_space' ? (
                    <FormattedMessage {...messages.sharedSpaces} />
                  ) : (
                    <FormattedMessage {...messages.bedroomNumber} values={{ number: room.roomNumber }} />
                  )}
                </h4>
                <div>
                  {room.bedTypes.map((bed, bedIndex) => (
                    <p key={bedIndex} style={{
                      marginBottom: '8px',
                      fontSize: '14px',
                      color: '#767676'
                    }}>
                      {bed.bedCount} × {bed.listsettings?.itemName || <FormattedMessage {...messages.bed} />}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // Fallback to old flat display
  let result, finalArray = [];

  if (itemList && itemList.length > 0) {
    result = itemList.reduce((acc, o) => (acc[o.listsettings && o.listsettings.itemName] = (acc[o.listsettings && o.listsettings.itemName] || 0) + 1, acc), {});
  }

  if (result) {
    finalArray = Object.keys(result).map(function (key) {
      return [key, Number(result[key])];
    });
  }

  return (
    <div className={cx(s.horizontalLineThrough)}>
      <div className={cx(s.space1)}>
        <p className={s.sectionTitleText}> {label} </p>
      </div>
      <div className={cx(s.spaceTop1)}>
        <div>
          {
            finalArray.map((item, i) => {
              return (
                <p key={i} className={s.splitList}>
                  {
                    item.map((inner, index) => {
                      return (
                        <span key={index}>{inner}{index == (item.length - 1) ? "" : ": "}</span>
                      )
                    })
                  }
                </p>
              )
            })
          }
        </div>
      </div>
    </div>
  );
}


ListBedTypes.propTypes = {
  itemList: PropTypes.arrayOf(PropTypes.shape({
    listsettings: PropTypes.shape({
      itemName: PropTypes.string,
      settingsType: PropTypes.shape({
        typeName: PropTypes.string
      }),
    }),
    spacesId: PropTypes.string,
  })),
  label: PropTypes.string.isRequired,
  rooms: PropTypes.arrayOf(PropTypes.shape({
    roomNumber: PropTypes.number,
    roomType: PropTypes.string,
    bedTypes: PropTypes.arrayOf(PropTypes.shape({
      bedCount: PropTypes.number,
      bedType: PropTypes.number,
      listsettings: PropTypes.shape({
        itemName: PropTypes.string,
      }),
    })),
  })),
};

export default withStyles(s)(ListBedTypes);